<template>
    <layout>
        <span slot="header">{{ title }}<button class="btn-pop-close delete" aria-label="close" @click="closeModal"></button></span>
        <div slot="content">
            <div class="btn-type1">
                <el-button size="mini" type="primary" icon="el-icon-plus" @click="addItem">추가</el-button>
                <el-button size="mini" type="primary" icon="el-icon-search" @click="goOpen">
                    {{ this.$i18n.messages[this.$store.state.locale].search }}
                </el-button>
            </div>
            <div class="pop-content-search">
              <el-form size="mini" @submit.prevent>
                <el-row :gutter="24">
                  <el-col :span="6">
                    <el-form-item label="제품군" label-width="70px">
                      <el-select v-model="form.itemGroup" @change="onItemGroupChange">
                        <el-option value='' label="전체">전체</el-option>
                        <el-option
                            v-for="item in combos['itemGroup']"
                            :key="item.value"
                            :value="item.key"
                            :label="item.value">
                        </el-option>
                      </el-select>
                    </el-form-item>
                  </el-col>

                  <el-col :span="6">
                    <el-form-item label="증상구분" label-width="70px">
                      <el-select v-model="form.subItemGroup">
                        <el-option value='' label="전체">전체</el-option>
                        <el-option
                            v-for="item in combos['subItemGroup']"
                            :key="item.value"
                            :value="item.key"
                            :label="item.value">
                        </el-option>
                      </el-select>
                    </el-form-item>
                  </el-col>

                  <el-col :span="6">
                    <el-form-item label="고장증상" label-width="70px">
                      <el-input v-model="form.catNm4"></el-input>
                    </el-form-item>
                  </el-col>
                  <el-col :span="6">
                    <el-form-item label="고장부위" label-width="70px">
                      <el-input v-model="form.catNm5"></el-input>
                    </el-form-item>
                  </el-col>
                </el-row>
              </el-form>
            </div>
            <div class="table-area">
                <div class="table-b">
                    <ag-grid-vue 
                        style="width: 100%; height: 320px;"
                        class="ag-theme-alpine"    
                        :framework-components="frameworkComponents"
                        :column-defs="columnDefs"
                        :grid-options="gridOptions"
                        :row-data="rowData"
                        :default-col-def="defaultColDef"
                        :statusBar="statusBar"
                        :enableRangeSelection="true"
                        @grid-ready="onGridReady" />
                </div>
            </div>
        </div>
    </layout>
</template>

<script>
import Layout from '@/components/Slot/ModalSlot.vue';
import CheckboxCellRenderer from "@/components/agGrid/checkbox-cell-renderer";
import lucoms from '@/mixin/lucoms';

/**
 * Url JOIN
 */
 function _url(...args) {
  args = args.map(x =>
      String(x || "")
          .trim()
          .replace(/^\/*|\/*$/g, "")
  );
  return args.filter(x => x).join("/");
}


export default {
    mixins: [lucoms],
    components: {Layout},
    props: {
      data: {
        Type: Array
        , required: false
      },
    },
    data() {
        return {
          title: '수리내역선택',
          // AG-GRID OPTION [START]
          rowData:[],
          gridOptions: {
            enableColResize: true,
            enableFilter: true,
            animateRows: false,
            enableSorting: true
          },
          frameworkComponents : {
            checkBox: CheckboxCellRenderer,
          },
          form: {
            companyId : this.$store.state.loginInfo.compCd,
            parentId : '',              // 제조사
            standDt : this.$moment(),
            itemGroup : '',             // 제품군
            subItemGroup : '',          // 제품상세
            catNm4 : '',                // 고장증상
            catNm5 : '',                // 고장부위
            sortType : '',              // 승인/정산처리유형
            page : 1,
            totalPage : 9999,
            curPage : 0,
            totalCount : 1,
            processTime : '',
          },
          combos: {
            'itemGroup' : [],        //제품군
            'subItemGroup' : [],     //증상구분
          },
          columnDefs:[
              {headerName:'선택', field: 'chk', width: 80, cellRenderer: 'checkBox',
                ellRendererParams: {
                  trueValue: true    //true값  지정 defalut-"Y" ex) "Y", true, "1"
                  , falseValue: false  //false값 지정 defalut-"N" ex) "N", false, "0"
                  , disable: true
                },
              },
              {headerName: '제품군', width:120, field:'catNm2', cellStyle:{textAlign:'left'}},
              {headerName: '증상구분', width:180, field:'catNm3', cellStyle:{textAlign:'left'}},
              {headerName: '고장증상', width:180, field:'catNm4', cellStyle:{textAlign:'left'}},
              {headerName: '고장부위', width:180, field:'catNm5', cellStyle:{textAlign:'left'}},
              {headerName: '내근 수리비', width:180, field:'repairFee1', cellStyle:{textAlign:'right'},
                valueFormatter: (params) => {
                  return this.getNumberFormat(params.value);
                }},
              {headerName:'외근 수리비', field:'repairFee2', width:110, cellStyle : {textAlign: 'right'},
                valueFormatter: (params) => {
                  return this.getNumberFormat(params.value);
                }},
          ],
          defaultColDef: {
              resizable: true,
              filter:true,
              sortable: true
          },
          statusBar: null,
        }
    },
    mounted() {
    },
    created() {
      this.statusBar = {
        statusPanels: [
          { statusPanel: 'agTotalRowCountComponent', align: 'right' },
        ],
      };
    },
    methods: {
        closeModal() {
            this.$parent.close();
        },
        onGridReady(){
            this.getCombo({flag: 'INIT'})
        },
        // rowDoubleClick(params){
        //     this.$emit('close', params.data);
        // },
        onCellClicked(event) {
            this.$emit('close', event);
            this.closeModal();
        },
        getCombo(param) {
            if(param.flag === 'INIT'){
                // 고객구분
              this.getItemGroupCombo();
              this.getItemGroupValue();
            } else {
            }
        },
        // 제품군 최초 selectbox 가져오기
        getItemGroupCombo(){
          this.$http.get(`/api/codeMng/combo`, { params: {parentId: 140} })
              .then(response => {
                this.combos['itemGroup'] = response.data || []
              });
        },
        // 제품군 변경시 subSelectbox 가져오기
        onItemGroupChange(param){
          this.form.subItemGroup = '';
            // 제품군
          this.$http.get(`/api/codeMng/detail`, { params: {parentId: 140} })  // 제품군
              .then(response => {
                let subData = response.data.filter(x => x.catKey === param);

                this.setSubItemGroupValue(subData[0].catId)
              });
        },
        // 모델의 정보가 있을 경우 제품군 selectbox 가져오기
        getItemGroupValue(){

          if(this.data.itemGroup.length > 0){

            const vform = {
              topKey: 'ModelGroup',
              catKey: this.data.itemGroup
            }

            this.$http.get(`/api/codeMng/detail`, { params: vform })
                .then(response => {
                  if(response.data.length === 1){
                    this.setItemGroupValue(response.data[0])
                  }
                });
          }
        },
        // 모델의 정보가 있을 경우 제품군 selectbox 가져오기
        setItemGroupValue(params) {
          this.$http.get(`/api/codeMng/detail`, { params: {parentId: 140} })
              .then(response => {
                let filter = response.data.filter(f => f.catValue1 === params.catKey);
                if(filter.length === 1){
                  this.form.itemGroup = filter[0].catKey
                  this.setSubItemGroupValue(this.form.itemGroup)
                }
              });
        },
        // 모델의 정보가 있을 경우 제품군 subSelectbox 가져오기
        setSubItemGroupValue(params) {
          this.$http.get(`/api/codeMng/combo`, { params: {parentId: params} })
              .then(response => {
                this.combos['subItemGroup'] = response.data || []
              });
        },

        goOpen(){
            this.$store.commit('loading')
            const vform = {
              companyId: this.$store.state.loginInfo.compCd,
              parentId : (this.form.subItemGroup.length <= 0 || this.form.subItemGroup === '')  ? (this.form.itemGroup === '' ? 0 : this.form.itemGroup)  : this.form.subItemGroup,          // 제품군
              standDt : this.$moment(),
              catNm4: this.form.catNm4,
              catNm5: this.form.catNm5,
              sortType: '',
              page: 1,
              totalPage: 9999,
              totalCount: 9999,
              curPage: 0,
              processTime : ''
            }

            this.$http.post("/api/obstacleTreatMng/detail", vform)
                .then(response => {
                  this.rowData = response.data;
            }).finally(() => {
                this.$store.commit('finish')
            });
        },
        addItem(param){
          /** 추가 */
          let list = this.rowData.filter(v => v.chk === 'Y');

          if(param && param.length === 1) {
            list = param;
          }

          if(list.length == 0){
            this.$swal({ type: 'warning', text: '사용자재를 선택해주세요.'});
            return false;
          }
          this.$emit('close', list);
        },
    }
}
</script>

<style lang="scss" scoped>
.modal-card {
  width: 970px;
}

.display-area {
  :global(img) {
    width: 100%;
  }
}
</style>